// extracted by mini-css-extract-plugin
module.exports = {"observadorFotoEdit":"ObservadorFormulariFoto_observadorFotoEdit__dlkSX"};